// see https://github.com/Microsoft/TypeScript/issues/16069
export function isDefined<T>(arg: T): arg is T extends undefined ? never : T {
  return arg !== undefined;
}

export function isTruthy<T>(arg: T): arg is T extends false ? never : NonNullable<T> {
  return Boolean(arg);
}

export type Except<T, U> = Pick<T, Exclude<keyof T, U>>
export type Extend<T, U> = U & Except<T, keyof U>

export type Mutable<T> = {
  -readonly [P in keyof T]: T[P] extends ReadonlyArray<infer U> ? Mutable<U>[] : Mutable<T[P]>
}
